module.exports = __webpack_public_path__ + "media/customizations/harvestlife/logo-99567fef40836b0671700b27d70e0618.png";